import { useI18n } from 'vue-i18n';
import moment from 'moment';
import {v4 as uuidv4} from 'uuid';
import { ICurrency } from '@/core/model/sys/ICurrency';
import { IPagedParameters } from '@/core/model/sys/IPagedParameters';
import { IAddress } from '@/core/model/sys/ICustomer';
import { ePathshomeEmpleado } from '@/core/model/GloblasEnum';
import { IRouteParam } from '@/core/stores/route-params';
import { IInvoice } from '@/core/model/sys/IInvoice';

export function isMobile():boolean
{
  return window.navigator.userAgent.toLowerCase().includes("mobi"); 
}
export function isEmail(value: string) 
{
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
export function traduceTexto(value:string) : string
{
    let newval = value;
    try
    {
        const { t } = useI18n();
        newval = t(value);
    }
    catch(e)
    {      
      newval = value;
    }
    return newval 
}
export function getNewId()
{
  return uuidv4();
}
export function getFullName(person: any)
{
  if(person)
    return `${person.Name} ${person.LastName}${person.MiddleName? ' ' + person.MiddleName:''}`;
  else
    return "";
}
export function getPlatform()
{  
  return process.env.VUE_APP_PLATFORM?.toLowerCase();
}
export function getWindow():any
{
  const win:any = window;
  return win;
}
export function getAppVersion()
{
  return process.env.VUE_APP_VERSION;
}
export function toDate2 (date:any, format = 'L') :Date 
{        
  return moment(date,format).toDate();
}
export function toDate (date:any):Date 
{        
  return moment(date).toDate();
}
/*export function toDateShort (date:any) 
{        
  return moment(date).format()
}*/
export function getLocale () 
{        
  const i18nLocale = useI18n();
  return i18nLocale.locale;     
}
export function getCurrencyLocale ():ICurrency 
{        
  const locale = getLocale();
  return {
    Locale:locale.value,
    Code:'MXN'
  }    
}
export function toCurrency(value: number,decimals?:number): string 
{
  if (isNaN(value)) 
  {
    return '';
  }
  const locale = getCurrencyLocale();
  const formatter = new Intl.NumberFormat(locale.Locale,
  {
      style: 'currency',
      currency: locale.Code,
      minimumFractionDigits: decimals
  });
  return formatter.format(value);
}
export function dateShort (date:any,localValue?:any) 
{        
  return dateFormat(date,'L',localValue);
}
export function dateFormat (date:any, format = 'L hh:mm a',localValue?:any) 
{        
  if(!localValue)
  {
    const i18nLocale = useI18n();
    moment.locale(i18nLocale.locale.value); 
  }
  else
  {
    moment.locale(localValue); 
  }
  return moment(date).format(format)
}
export function empresaShortName (empresa: any) 
{        
  return empresa? empresa.RazonSocial:"";
}
 /**Convierte un string en un byte[] to c# */
export function Base64ToArrayBuffer2(base64: string)
{
  const res = Base64ToArrayBuffer(base64);  
  const buffer = new Uint8Array(res);
  return [].slice.call(buffer); 
}

export function Base64ToArrayBuffer(base64: string)
{
  const binarystring = window.atob(base64);
  const len = binarystring.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++)
  {
      bytes[i] = binarystring.charCodeAt(i);
  }
  return bytes.buffer;
}
export function ArrayBufferaToBase64(buffer: any)
{
  return btoa(buffer.reduce((x:any, y:any) => x + String.fromCharCode(y), ''));
}
export function formatCurrency(value:any,localValue?:any) 
{  
  return localValue? new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value) : value;
}
export function hasPermiso(permisos:any[]|undefined, permiso:number):boolean
{
  if(!permisos || permisos.length <= 0) return false;
  const existe = permisos.find((x:any) => x.PermisoMenuId === permiso);
  return existe;
}
export async function ConvertBlobToBase64 (blob: Blob): Promise<string>
{
  return new Promise((resolve, reject) => 
  {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => { resolve(reader.result as string); };
    reader.readAsDataURL(blob);
  });
}
export function getDefaultPaged():IPagedParameters
{
  return {
    Page:1,
    Search:'',
    SecondaryId:null
  }
}
export function getMainAddress(address:IAddress|null):string
{
  if(address)
  {            
    return `${address.Street} ${address.NumExt}`;
  }
  return "";
}
export function getParam(path:ePathshomeEmpleado,params:Array<IRouteParam>)
{
const find = params.findIndex((x:IRouteParam) => x.route === path);
if(find >= 0)
{        
  return params[find].param
}
else
return null;
} 
export function IsMimeImageValid(mime: string): boolean
{
  const mimes = ['image/jpeg', 'image/png', 'image/jpg'];
  const existe = mimes.find((e: string) =>  e.toString().toLocaleLowerCase() === mime.toString().toLocaleLowerCase());
  return (existe) ? true : false;
}
export function HasInvoicePeriod(invoice: IInvoice): boolean
{
  if(invoice && invoice.InitialPeriod && invoice.FinalPeriod)
  {
    return true;
  }
  else
  {
    return false;
  }
}
export function GetInvoicePeriod(invoice: IInvoice): Array<number>
{
  let ini = 0;
  let end = 0;
  ini = invoice.InitialPeriod? toDate(invoice.InitialPeriod).getMonth():0;    
  end = invoice.FinalPeriod? toDate(invoice.FinalPeriod).getMonth():0;    
  if(ini != end) return [ini,end]
  else return [ini]
}
export function GetInvoicePeriod2(InitialPeriod:Date|null|undefined,FinalPeriod: Date|null|undefined): string
{  
  let ini = 0;
  let end = 0;
  let iniyear = 0;
  let endyear = 0;
  let year = 0
  ini = InitialPeriod? toDate(InitialPeriod).getMonth():-1;    
  end = FinalPeriod? toDate(FinalPeriod).getMonth():-1;
  if(ini < 0 || end < 0) return '';    
  iniyear = InitialPeriod? toDate(InitialPeriod).getFullYear():0;    
  endyear = FinalPeriod? toDate(FinalPeriod).getFullYear():0;   
  if(iniyear === endyear) year = iniyear;
  else year = 0;  
  if(ini != end || iniyear != endyear) return `${traduceTexto('prime.monthNames[' + ini +']')} ${!year?iniyear:''} - 
                         ${traduceTexto('prime.monthNames[' + end +']')} ${year?year: endyear} `; 
  else return traduceTexto('prime.monthNames[' + ini +']') + ' ' +iniyear ;  
}
export function GetInvoicePeriod3(invoice: IInvoice):string
{
  return GetInvoicePeriod2(invoice.InitialPeriod,invoice.FinalPeriod);  
}
export function FirstDate(date:Date):Date
{
  return new Date(date.getFullYear(),date.getMonth(),1);
}
export function LastDate(date:Date):Date
{
  const last = new Date(date.getFullYear(),date.getMonth()+1,1);
  last.setDate(last.getDate() -1);
  return last;
}